import { render, staticRenderFns } from "./HandleNotify.vue?vue&type=template&id=7572e956&"
import script from "./HandleNotify.vue?vue&type=script&lang=js&"
export * from "./HandleNotify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HandleNotify.vue"
export default component.exports